export const questionTypes = Object.freeze({
  BANDED: "question_banded",
  SELECT: "question_select",
  STOCK: "question_stock",
  SLOT_RANDOM: "slot_random",
  UPLOAD: "question_upload"
});
